// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { isIpPool } from "@dashboardApi/apis/companiesCompanyIdEmailSelfServeConfigurationData";

export const isPostCompaniesCompanyIdEmailSelfServeIpAddressesResult = objectOf({
  ipPool: isIpPool,
});
